const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
function SvgLogOutWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 113 114",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Nuevos i\u0301conos 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56,9.6V43.4a2.56,2.56,0,0,0,1.65,2.25,4,4,0,0,0,3.29,0,2.56,2.56,0,0,0,1.65-2.25V9.6a2.56,2.56,0,0,0-1.65-2.25,4,4,0,0,0-3.29,0A2.56,2.56,0,0,0,56,9.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.92,62A47.9,47.9,0,1,1,35.33,20.39a2.4,2.4,0,1,1,2.38,4.17,43.1,43.1,0,1,0,42.62,0,2.4,2.4,0,0,1,2.38-4.17A48.05,48.05,0,0,1,106.92,62Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOutWhite);
export default __webpack_public_path__ + "static/media/log_out_white.1f96678c62a5e50a4f65e33a7c2a29dc.svg";
export { ForwardRef as ReactComponent };